import { AfterViewInit, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  standalone: true,
  imports: [RouterLink, MatIconModule]
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  authService = inject(AuthService);

  private checkUserInterval: any;
  private checkLabInterval: any;
  private timeoutUserHandle: any;
  private timeoutLabHandle: any;
  private readonly intervalTime = 100; // Check every 100 milliseconds
  private readonly timeoutTime = 2000; // Timeout after 5000 milliseconds (5 seconds)

  navbarCollapsed: boolean;

  userName = signal<string>('');
  labName = signal<string>('');

  constructor() {
    this.navbarCollapsed = true;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.waitForLocalStorageVariable();
  }

  /**
   * Periodically checks local storage for the presence of a 'user' variable.
   * Once the 'user' variable is found, the interval is cleared and its value
   * is emitted to the userIdSubject$ observable.
   *
   * @return {void} This method does not return a value.
   */
  private waitForLocalStorageVariable(): void {
    this.checkUserInterval = setInterval(() => {
      if (localStorage.getItem('user') != null) {
        clearInterval(this.checkUserInterval);
        clearTimeout(this.timeoutUserHandle);
        this.userName.set(localStorage.getItem('user') || '');
      }
    }, this.intervalTime);
    this.timeoutUserHandle = setTimeout(() => {
      clearInterval(this.checkUserInterval);
      console.warn('Timeout: LocalStorage variable was not set within the expected time.');
    }, this.timeoutTime);

    this.checkLabInterval = setInterval(() => {
      if (localStorage.getItem('laboratory') != null) {
        clearInterval(this.checkLabInterval);
        clearTimeout(this.timeoutLabHandle);
        this.labName.set(JSON.parse(localStorage.getItem('laboratory')).name || '');
      }
    }, this.intervalTime);
    this.timeoutLabHandle = setTimeout(() => {
      clearInterval(this.checkLabInterval);
      console.warn('Timeout: LocalStorage variable was not set within the expected time.');
    }, this.timeoutTime);
  }

  logOut() {
    this.authService.onSignout();
  }

  ngOnDestroy() {
    clearInterval(this.checkUserInterval);
    clearInterval(this.checkLabInterval);
    clearTimeout(this.timeoutUserHandle);
    clearTimeout(this.timeoutLabHandle);
  }
}
